'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconArrowCircleUp = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0zm6.761 16.138a1.251 1.251 0 0 1-1.753-.232L12.2 9.635a.249.249 0 0 0-.4 0l-4.81 6.271a1.25 1.25 0 1 1-1.984-1.521l5.634-7.346a1.779 1.779 0 0 1 2.716 0l5.634 7.346a1.25 1.25 0 0 1-.229 1.753z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z' }),
    _react2.default.createElement('path', { d: 'M18.5 16a.495.495 0 0 1-.397-.197l-6.1-7.99-6.105 7.99a.499.499 0 0 1-.701.095.5.5 0 0 1-.095-.701l6.106-7.99a1.003 1.003 0 0 1 .926-.384c.265.035.5.171.662.384l6.1 7.99A.499.499 0 0 1 18.5 16z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z' }),
    _react2.default.createElement('path', { d: 'M6.75 15.75a.749.749 0 0 1-.633-1.153l4.617-7.256a1.492 1.492 0 0 1 1.589-.659c.392.087.727.32.942.658l4.617 7.257a.751.751 0 0 1-1.266.806L12 8.147l-4.617 7.256a.748.748 0 0 1-.633.347z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowCircleUp.displayName = 'IconArrowCircleUp';
exports.default = IconArrowCircleUp;